import { FieldError } from "react-hook-form/dist/types"

export const deriveErrorMessage = (error: FieldError): string => {
	if (error.type === "required") {
		return "This field must not be empty"
	}

	return error.message || "Unknown error"
}
